import React, { useState } from 'react';

import BottomSheet from 'components/BottomSheet';

interface GlobalBottomSheetCreateContext {
  set: (arg: SetArgument) => void;
  reset: () => void;
  hide: () => void;
  show: () => void;
  setVisible: (visible: boolean) => void;
  isVisible: () => boolean;
  setContent: (content: React.ReactNode) => void;
  setOptions: (options: Options) => void;
}

interface GlobalBottomSheetCreateProviderProps {
  children?: React.ReactNode;
}

type Options = {
  noPadding?: boolean;
  noHeader?: boolean;
  header?: JSX.Element;
  title?: string;
  style?: React.CSSProperties;
  modal?: boolean;
};

type SetArgument = {
  content: React.ReactNode;
  onClose: () => void;
  options?: Options;
};

const GlobalBottomSheetContext = React.createContext({} as GlobalBottomSheetCreateContext);

export const GlobalBottomSheetProvider = ({ children }: GlobalBottomSheetCreateProviderProps) => {
  const [visible, setVisible] = useState(false);
  const [content, setContent] = useState<React.ReactNode>(null);
  const [onClose, setOnClose] = useState<{ fn: () => void }>({ fn: () => {} });
  const [options, setOptions] = useState<Options>({});

  const set = (arg: SetArgument) => {
    setContent(arg.content);
    setOnClose({ fn: arg.onClose });
    if (arg.options) setOptions(arg.options);
    setVisible(true);
  };
  const reset = () => {
    setVisible(false);
    setContent(null);
    setOnClose({ fn: () => {} });
    setOptions({});
  };
  const hide = () => setVisible(false);
  const show = () => setVisible(false);
  const isVisible = () => visible;

  return (
    <GlobalBottomSheetContext.Provider
      value={{ set, reset, show, hide, setVisible, isVisible, setContent, setOptions }}
    >
      <BottomSheet show={visible} onClose={onClose.fn} zIndex={100} {...options}>
        {content}
      </BottomSheet>
      {children}
    </GlobalBottomSheetContext.Provider>
  );
};

export default GlobalBottomSheetContext;
